import { render } from "./number_step.vue?vue&type=template&id=89f1456c"
import script from "./number_step.vue?vue&type=script&lang=js"
export * from "./number_step.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__